// eslint-disable-next-line no-unused-vars
import React from 'react';

import ProductCard2Container from 'Containers/Templates/ProductCard2';

const ProductCard2 = {
  label: 'Product Card 2',
  fields: {
    productId: { type: 'text', label: 'Product ID' },
    title: { type: 'text', label: 'Title' },
    specs: {
      type: 'array',
      label: 'Specs',
      arrayFields: {
        label: { type: 'text', label: 'Label' },
        value: { type: 'textarea', label: 'Value' },
      },
      getItemSummary: item => item.label || item.value || 'Spec',
    },
  },
  defaultProps: {
    productId: '',
    title: '',
    specs: [],
  },
  render: ({ productId, title, specs }) => (
    <ProductCard2Container
      productId={ productId }
      title={ title }
      specs={ specs }
    />
  ),
};

export { ProductCard2 };
